import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

/**
 * Build KitchenDebugData from a Kitchen domain object.
 * Mirrors the logic in Render3DKitchen's updateKitchenDebugData.
 */
const buildKitchenDebugData = (kitchen: any): any | null => {
	if (!kitchen?.getSize) return null;

	try {
		const kitchenSize = kitchen.getSize(true);
		return {
			origin: kitchenSize.origin || { x: 0, y: 0, z: 0 },
			size: {
				width: kitchenSize.width || 0,
				height: kitchenSize.height || 0,
				depth: kitchenSize.depth || 0
			},
			left: kitchenSize.left ? {
				origin: kitchenSize.left.origin || { x: 0, y: 0, z: 0 },
				size: {
					width: kitchenSize.left.size?.width || 0,
					height: kitchenSize.left.size?.height || 0,
					depth: kitchenSize.left.size?.depth || 0
				}
			} : undefined,
			right: kitchenSize.right ? {
				origin: kitchenSize.right.origin || { x: 0, y: 0, z: 0 },
				size: {
					width: kitchenSize.right.size?.width || 0,
					height: kitchenSize.right.size?.height || 0,
					depth: kitchenSize.right.size?.depth || 0
				}
			} : undefined,
			defaultIslandX: 0
		};
	} catch {
		return null;
	}
};

export async function resetView (args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, kitchen, publish } = context;

	// resetView can be called before the 3D scene is fully initialized
	// (e.g., right after set_kitchen_shape which triggers a rebuild).
	// In that case, the event-driven repositionCamera callback on the
	// engine will handle the reset once the scene is ready.
	if (!threeInstance) {
		return { success: true, data: { action: 'reset_view', deferred: true } };
	}

	const kitchenDebugData = buildKitchenDebugData(kitchen);
	await threeInstance.resetView(kitchenDebugData ?? undefined);

	publish('camera', 'change', {
		ref: 'reset_view',
		old: null,
		new: null
	});

	return { success: true, data: { action: 'reset_view' } };
}
